import { render } from "./FBTComponent.vue?vue&type=template&id=864b852c&scoped=true"
import script from "./FBTComponent.vue?vue&type=script&lang=js"
export * from "./FBTComponent.vue?vue&type=script&lang=js"

import "./FBTComponent.vue?vue&type=style&index=0&id=864b852c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864b852c"]])

export default __exports__